import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

const CTA = () => {
  return (
    <section className="py-24 px-6">
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className="text-3xl md:text-5xl font-serif font-semibold text-foreground mb-8">
          Ready to transform your community experience?
        </h2>

        <Button variant="hero" size="lg" className="gap-2" asChild>
          <Link to="/login">
            Get started today
            <ArrowUpRight className="w-4 h-4" />
          </Link>
        </Button>
      </div>
    </section>
  );
};

export default CTA;
